// extracted by mini-css-extract-plugin
module.exports = {"link":"link-button_link__h57Vu","link-secondary":"link-button_link-secondary__eQSlM","link-text":"link-button_link-text__uTuIl"};